<template>
    <div class="mobile-results-list d-lg-none" :class="{ 'show-list': showList }" ref="mobileResultsList">
        <div v-if="isSearching && isSearch" class="searching-wrapper">
            <i class="fa fa-spin fa-spinner" />
        </div>
        <div v-else class="wrapper">
          <div v-if="isSearch && locationsList" class="border-bottom p-3 h-auto">
            <div v-if="searchQuery !== ''">{{ _.size(locationsList) }} platser hittades för {{ searchQuery }}</div>
            <div v-else>{{ _.size(locationsList) }} platser hittades</div>
          </div>
            <transition name="no-places">
                <div v-if="!isSearch && locationsList && locationsList.length === 0" class="border-bottom p-3 text-center">
                    <div>Du visar inga platser i kartan just nu.</div>
                    <a href="#" @click.prevent="handleVastmanlandClick">Visa hela Västmanland</a>
                </div>
            </transition>
            <transition-group name="list" tag="div">
                <div
                        :key="location.id"
                        v-for="location in locationsList"
                        class="result-item border-bottom p-3 d-block"
                        @click="handleItemClick(location)"
                        @mouseover="handleHoverLocation(location)"
                        @mouseout="handleHoverLocation(location, true)">
                    <h5 class="mb-0">{{ location.name }}</h5>
                    <span><i class="far fa-file-alt" /> {{ location.num_related_articles }} {{ location.num_related_articles === 1 ? 'artikel' : 'artiklar' }}</span>
                    <span v-if="location.distance"> | <i class="fas fa-walking" /> {{ getDistanceString(location.distance) }}</span>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MobileResultsList',

  props: [
    'isSearching',
    'searchQuery',
    'isSearch',
    'locationsList',
    'handleFocusLocation',
    'handleHoverLocation',
    'showList'
  ],

  data () {
    return {

    }
  },

  methods: {
    handleVastmanlandClick: function () {
      Bus.$emit('zoomInVastmanland')
    },

    handleItemClick: function (location) {
      window.location.href = location.resource_url
    },

    getDistanceString: function (value) {
      return value < 1000
        ? `${value}m`
        : `${(value / 1000).toFixed(2)}km`
    }
  }
}
</script>

<style scoped>

</style>
